import React from "react";
import ReminderBlock from "../ReminderBlock";
import { NoDataContainer } from "../TreeComponent/TreeComponentStyled";
import { Box, Button, Typography } from "@mui/material";
import { DrawerFormBody } from "./DrawerStyled";
import { ShareIcon } from "../../assets/icons";
import PropTypes from 'prop-types';

const PeopleWithAccessTab = ({
  reviewers,
  remindInProgressIds,
  handleRemindClick,
  formatSharedDate,
  remindStatus,
  setShowShareModal,
}) => {
  const hasReviewers = reviewers && reviewers.length > 0;

  return (
    <DrawerFormBody
      style={{
        height: "calc(100% - 24px)",
        justifyContent: "space-between",
      }}
    >
      {hasReviewers ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Box
              style={{
                fontWeight: 600,
                marginBottom: "12px",
                fontSize: "13px",
                fontFamily: "Manrope"
              }}
            >
              Internal
            </Box>
            <ReminderBlock
              reviewers={reviewers}
              remindInProgressIds={remindInProgressIds}
              handleRemindClick={handleRemindClick}
              formatSharedDate={formatSharedDate}
            />
          </Box>
          <Box>
            {remindStatus && (
              <Typography
                sx={{
                  fontFamily: "manrope",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: remindStatus.success ? "#128F4E" : "#E53935",
                }}
              >
                {remindStatus.success
                  ? `Reminder sent to ${remindStatus.user}`
                  : `Error in reminding ${remindStatus.user}`}
              </Typography>
            )}
          </Box>
        </Box>
      ) : (
        <NoDataContainer
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          No reviewers have been added to this file yet.
        </NoDataContainer>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          // paddingTop: "24px",
        }}
      >
        <Button
          variant="contained"
          endIcon={<ShareIcon />}
          disabled={false}
          onClick={() => {
            setShowShareModal(true);
          }}
          sx={{
            backgroundColor: "#0057d9",
            color: "#fff",
            textTransform: "none",
            padding: "6px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "0px",
            flexShrink: 0,
            width: "fit-content",
            "& .MuiButton-endIcon": {
              marginLeft: "4px",
            },
            "&:hover": {
              backgroundColor: "#004bb5",
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#9e9e9e",
            },
          }}
        >
          Share
        </Button>
      </Box>
    </DrawerFormBody>
  );
};

PeopleWithAccessTab.propTypes = {
  reviewers: PropTypes.array.isRequired,
  remindInProgressIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleRemindClick: PropTypes.func.isRequired,
  formatSharedDate: PropTypes.func.isRequired,
  remindStatus: PropTypes.shape({
    success: PropTypes.bool.isRequired,
    user: PropTypes.string.isRequired,
  }).isRequired,
  setShowShareModal: PropTypes.func.isRequired,
};

export default PeopleWithAccessTab;
